import * as React from 'react';
import { STAR_SIZE_MAP } from '../../constants/star';
import { useGradient } from '../../hooks/useGradient';
import { jsx as _jsx } from "react/jsx-runtime";
export function Star(props) {
  var size = props.size,
    theme = props.theme;
  var StarComponent = React.useMemo(function () {
    return STAR_SIZE_MAP[size];
  }, [size]);
  var _useGradient = useGradient({
      value: 'value' in props ? props.value : undefined,
      theme: theme,
      color: 'color' in props ? props.color : undefined
    }),
    gradient = _useGradient.gradient,
    fill = _useGradient.fill;
  return /*#__PURE__*/_jsx(StarComponent, {
    gradient: gradient,
    fill: fill
  });
}